import router from './router'
import { setDocumentTitle } from '@/utils/domUtil'
import NProgress from 'nprogress'
import { post } from '@/utils/http'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

/**
 * no redirect whitelist
 * scanSupplierResult：扫描结果
 */
let flag=false
router.beforeEach((to, from, next) => {
    NProgress.start(); // start progress bar
    // console.log(from)
    // console.log(to)
    // console.log(from.name, to.name)

    to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${to.meta.title} `));


    if (['home', 'home1', 'home2', 'home3'].includes(to.name)&&!flag) {
        console.log("1----------");
        // 缓存，10秒内，不需要再重复调用
        // next()
        post(`/api/public/v2/h5/tracing/${to.query.traceCode}/findUsedTraceTemplates`, {}, false).then((res) => {
            
            if (from.name === 'home' + res.data.sort) {
                next();
                return;
            }else{
                flag=true
                next({ path: '/home' + res.data.sort, query: { traceCode: to.query.traceCode } });
            }
          
        }).catch(err => {
            console.log(err);
            next();
        });
    }else if (['home6', 'home7', 'home8'].includes(to.name)&&!flag) {
        console.log("1----------");
        // 缓存，10秒内，不需要再重复调用
        // next()
        post(`/api/public/v2/h5/tracing/${to.query.traceCode}/findUsedTraceTemplatesByProductId`, {}, false).then((res) => {
            
            if (from.name === 'home' + res.data.sort) {
                next();
                return;
            }else{
                flag=true
                next({ path: '/home' + res.data.sort, query: { traceCode: to.query.traceCode } });
            }
          
        }).catch(err => {
            console.log(err);
            next();
        });
    }else{
        next()
    }
    //短链
    if (null === to.name) {
        console.log("触发null");
        next({ path: '/home', query: { traceCode: to.path.replace("/", "") } });
        
    } else {
        next();
    }
    NProgress.done();


})

router.afterEach(() => {
    NProgress.done() // finish progress bar
})